import { render, staticRenderFns } from "./EdgeBuilderChart.vue?vue&type=template&id=5dbbcfe5&scoped=true&"
import script from "./EdgeBuilderChart.vue?vue&type=script&lang=ts&"
export * from "./EdgeBuilderChart.vue?vue&type=script&lang=ts&"
import style0 from "./EdgeBuilderChart.vue?vue&type=style&index=0&id=5dbbcfe5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbbcfe5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VMenu,VRow,VSpacer})
